import { createAsyncThunk } from '@reduxjs/toolkit';

import { authGet } from '../../../utils/request';

const getCoOrders = createAsyncThunk('coOrders/getCoOrders',
  async (_, { rejectWithValue, getState }) => {
    try {
      const {
        page, size, order, query,
        orderStatus, orderAssemblyType, orderAssemblyStyle,
        fromId, toId, marketplaceDateFrom,
        marketplaceDateTo, doneByUser, assembledDateTo, assembledDateFrom
      } = getState().coOrdersFilter;
      const { data } = await authGet('/co/orders',
        {
          params: {
            size,
            page,
            ...(orderStatus && { orderStatus }),
            ...(orderAssemblyType && { orderAssemblyType }),
            ...(orderAssemblyStyle && { orderAssemblyStyle }),
            ...(fromId && { fromId }),
            ...(toId && { toId }),
            ...(marketplaceDateFrom && { marketplaceDateFrom }),
            ...(marketplaceDateTo && { marketplaceDateTo }),
            ...(assembledDateTo && { assembledDateTo }),
            ...(assembledDateFrom && { assembledDateFrom }),
            ...(order && { order }),
            ...(query && { query }),
            ...(doneByUser && { doneByUser }),
          }
        });
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  });

export default getCoOrders;
